/* eslint-disable */
export const getLocalStorage = () => {
  return navigator.cookieEnabled && window.localStorage
    ? window.localStorage
    : fallbackStorage;
};

const fallbackStorage = {
  storage: {},
  setItem(key, value) {
    this.storage[key] = value;
  },
  getItem(key) {
    return this.storage[key];
  },
  clear() {
    this.storage = {};
  },
  key(index) {
    return Object.keys(this.storage)[index];
  },
  removeItem(key) {
    delete this.storage[key];
  },
  get length() {
    return Object.keys(this.storage).length;
  }
};
